"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGovActionType = exports.GovActionType = void 0;
var GovActionType;
(function (GovActionType) {
    GovActionType[GovActionType["ParameterChange"] = 0] = "ParameterChange";
    GovActionType[GovActionType["InitHardFork"] = 1] = "InitHardFork";
    GovActionType[GovActionType["TreasuryWithdrawals"] = 2] = "TreasuryWithdrawals";
    GovActionType[GovActionType["NoConfidence"] = 3] = "NoConfidence";
    GovActionType[GovActionType["UpdateCommittee"] = 4] = "UpdateCommittee";
    GovActionType[GovActionType["NewConstitution"] = 5] = "NewConstitution";
    GovActionType[GovActionType["Info"] = 6] = "Info";
})(GovActionType = exports.GovActionType || (exports.GovActionType = {}));
;
Object.freeze(GovActionType);
function isGovActionType(stuff) {
    return typeof stuff === "number" && (stuff >= 0 && stuff <= 6 &&
        stuff === Math.round(stuff));
}
exports.isGovActionType = isGovActionType;
